<script>
export default {
	name: "AdvancedFilterOption",
	inject: ["advancedFilterState"],
	props: {
		field: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		icon: {
			type: String,
		},
		operators: {
			type: Array,
			required: false
		},
		type: {
			type: String,
			default: "text"
		},
		options: {
			type: Array
		}
	},
	created() {
		this.advancedFilterState?.options.push({
			field: this.field,
			label: this.label,
			icon: this.icon,
			operators: this.operators,
			options: this.options,
			type: this.type
		})
	},
	render() {
	}
}
</script>